import React, { useEffect, useState } from 'react';
import {
    Box,
    CssBaseline,
    Grid,
    IconButton,
    ThemeProvider,
} from '@mui/material';
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { useTranslation, I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import Store from '../../Store';
import MainRouting from './routes/MainRouting';
import MainRouteTraval from './routes/MainRouteTraval';
import MainRouteFooter from './routes/MainRouteFooter';

function MainPage({ screenWidth, defaultTheme }) {
    const { t, i18n } = useTranslation();
    const [index, setIndex] = useState(0);
    // สร้าง state เพื่อบังคับ rerender เมื่อเปลี่ยนภาษา
    const [language, setLanguage] = useState(i18n?.language);

    // ตั้ง listener ภาษาเปลี่ยน
    useEffect(() => {
        setLanguage(i18n.language);
    }, [i18n.language]);



    const prevSlide = () => {
        setIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };
    const nextSlide = () => {
        setIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    };


    // ชื่อไฟล์เดียวกันมีครบทั้ง img-mobile / img-ipad / img-web — <picture> ด้านล่างเลือกโฟลเดอร์ตามความกว้างจอ
    const images = language === 'th'
        ? ['อำเภอเมือง.jpg', 'ภูผาม่าน.jpg', 'อุบลรัตน์.jpg', 'ภูเวียง.jpg', 'น้ำพอง.jpg', 'สีชมพู.jpg']
        : ['mueang.jpg', 'phuphaman.jpg', 'ubolrat.jpg', 'phuwiang.jpg', 'namphong.jpg', 'sichompgu.jpg'];
    // console.log("images", images);

    return (
        <ThemeProvider theme={defaultTheme}>
            <Provider store={Store}>
                <CssBaseline />
                <Grid
                    sx={{
                        minHeight: '100vh',
                        fontWeight: 'bold',
                        color: '#000000',
                        position: 'relative',
                        flexDirection: 'column',
                    }}
                >
                    <Box
                        component="main"
                        // sx={{
                        //     height: "100vh",
                        //     alignItems: "center",
                        //     justifyContent: "center",
                        //     overflow: "hidden",
                        // }}
                        sx={{
                            // สัดส่วนเดิม 70 / 80 / 100% ของความสูงจอ แต่คำนวณจากจอที่มองเห็นจริง และหัก header (64px) ออก
                            height: {
                                xs: 'calc(var(--app-vh, 1vh) * 70)',
                                sm: 'calc(var(--app-vh, 1vh) * 80)',
                                md: 'calc(var(--app-vh, 1vh) * 100 - 64px)',
                            },
                            minHeight: 280,
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                            position: 'relative',
                        }}
                    >
                        <picture style={{ display: "block", height: "100%" }}>
                        {/* มือถือ < 600px, iPad 600–1024px, คอม > 1024px */}
                        <source media="(max-width: 599px)" srcSet={`/img-mobile/${images[index]}`} />
                        <source media="(max-width: 1024px)" srcSet={`/img-ipad/${images[index]}`} />
                        <img
                            src={`/img-web/${images[index]}`}
                            alt={`Slide ${index}`}
                            // style={{
                            //     width: "100%",
                            //     maxHeight: "100vh",
                            //     objectFit: "cover",
                            //     transition: "all 0.5s ease-in-out",
                            // }}
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                display: "block", // กันช่องว่างใต้รูป (inline baseline)
                                transition: "all 0.5s ease-in-out",
                            }}
                        />
                        </picture>

                        <IconButton
                            onClick={prevSlide}
                            sx={{ position: "absolute", left: 20, top: "50%", transform: "translateY(-50%)", color: "white" }}
                        >
                            <ArrowBackIos />
                        </IconButton>

                        <IconButton
                            onClick={nextSlide}
                            sx={{ position: "absolute", right: 20, top: "50%", transform: "translateY(-50%)", color: "white" }}
                        >
                            <ArrowForwardIos />
                        </IconButton>
                    </Box>
                    <Box // 2
                        component="main"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                            position: 'relative',  // ต้องกำหนดเพื่อให้ ::before ทำงาน
                            backgroundImage: `url('/backgroun.jpg')`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',

                            // ✅ เพิ่ม overlay จางๆ ด้วย pseudo-element
                            '&::before': {
                                content: '""',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                backgroundColor: 'rgba(255, 255, 255, 0.4)', // สีขาวจาง // ปรับค่าความจาง (0.1 = จางน้อย, 0.5 = มืดลง)
                                zIndex: 1,
                            },
                            // ✅ ยก zIndex ให้เนื้อหาอยู่บน overlay
                            '& > *': {
                                position: 'relative',
                                zIndex: 2,
                            },
                        }}

                    >
                        <MainRouting screenWidth={screenWidth} />
                    </Box>
                    <Box // 3
                        component="main"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                            position: 'relative',
                            backgroundColor: '#77B349', // เพิ่มพื้นหลังสีดำโปร่งแสง
                            fontSize: { xs: '0.8rem', sm: '1rem' }, // ปรับขนาดตัวอักษรให้เล็กลงสำหรับมือถือ
                            display: 'flex',
                            flexDirection: 'column', // ✅ เรียงแนวตั้ง
                            gap: 2, // เพิ่มระยะห่างระหว่าง item ในแนวตั้ง
                        }}
                    >
                        <MainRouteTraval />
                    </Box>
                    <Box // 3
                        component="main"
                        sx={{
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                            // backgroundColor: '#77B349', // เพิ่มพื้นหลังสีดำโปร่งแสง
                            fontSize: { xs: '0.8rem', sm: '1rem' }, // ปรับขนาดตัวอักษรให้เล็กลงสำหรับมือถือ
                            display: 'flex',
                            flexDirection: 'column', // ✅ เรียงแนวตั้ง
                            gap: 2, // เพิ่มระยะห่างระหว่าง item ในแนวตั้ง
                        }}
                    >
                        <MainRouteFooter screenWidth={screenWidth} />
                    </Box>
                </Grid>
            </Provider>
        </ThemeProvider>
    )
}

export default MainPage